import React, { useState } from 'react';
import { WidgetModalWindow } from '../widget-configuration/WidgetModalWindow';
import { IWidgetPreviewProps, Widget } from '../widget-configuration/Widget';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';

export const WidgetPreview = (props: IWidgetPreviewProps): JSX.Element => {
	const { t } = useTranslation();
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const onClose = (): void => setIsModalOpen(false);
	return (
		<div className="mt-10 mt-md-0  ms-auto me-auto ">
			<div className="d-flex justify-content-between align-items-center mt-5 mt-xl-0 mb-5 mb-xl-2 ">
				<div className="fs-4 fw-bolder">{t('COLOR_MODULE.WIDGET_PREVIEW_TITLE')}</div>
				<ButtonComponent
					onButtonClick={(): void => setIsModalOpen(true)}
					buttonName='Simulate'
					buttonType={BUTTON_TYPE.TRANSPARENT}
					additionalClass="d-xl-none d-block "
				/>
			</div>
			<Widget {...props}/>

			<ButtonComponent
				onButtonClick={(): void => setIsModalOpen(true)}
				buttonName='Simulate'
				buttonType={BUTTON_TYPE.TRANSPARENT}
				additionalClass="mt-5 d-none d-xl-block"
			/>

			<WidgetModalWindow
				isOpen={isModalOpen}
				onClose={onClose}
				content={<Widget {...props} onClose={onClose}/>}
			/>
		</div>

	);
};
